import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Channels/Channel'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Channels/Channel'
import { mediaPlatformChannelsRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Channels/Routing'

export const mediaPlatformChannelRoute = createRoute({
  getParentRoute: () => mediaPlatformChannelsRoute,
  path: DynamicRouteParameterWPrefix.CHANNEL_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const mediaPlatformChannelLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformChannelRoute,
  id: 'mediaPlatformChannelLayout',
  component: Structure,
})

export const mediaPlatformChannelRawRoute = createRoute({
  getParentRoute: () => mediaPlatformChannelLayoutRoute,
  path: '/',
  component: Overview,
})
